/**
 * Keep header tire finder drawer off the page until opened.
 */
(function () {
  function parkDrawer() {
    var drawer = document.getElementById("specr-finder-drawer");
    if (!drawer) return;

    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    if (!drawer.classList.contains("is-open")) {
      drawer.setAttribute("hidden", "");
      drawer.style.display = "none";
    }
  }

  parkDrawer();
  document.addEventListener("DOMContentLoaded", parkDrawer);
  document.addEventListener("shopify:section:load", parkDrawer);
})();
